// removed by extract-text-webpack-plugin
module.exports = {"directions":"src-containers-Branch----Branch-module---directions---3Yu52","container":"src-containers-Branch----Branch-module---container---73GpA","cols":"src-containers-Branch----Branch-module---cols---3HCd8","detailsWrapper":"src-containers-Branch----Branch-module---detailsWrapper---HsvNh","mapWrapper":"src-containers-Branch----Branch-module---mapWrapper---2rVJk","backlinkWrapper":"src-containers-Branch----Branch-module---backlinkWrapper---Tg7D7"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Branch/Branch.module.scss
// module id = 1211
// module chunks = 211695687906892